module.exports = __webpack_public_path__ + "static/img/kongke.0dec38a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/kongke.jpg
// module id = Qcef
// module chunks = 0